<span class="kt-badge kt-badge--dark kt-badge--inline" *ngIf="status === 1"> New </span>
<span class="kt-badge kt-badge--primary kt-badge--inline" *ngIf="status === 2"> Viewed </span>
<span class="kt-badge kt-badge--success kt-badge--inline" *ngIf="status === 3"> Imported </span>
<span class="kt-badge kt-badge--warning kt-badge--inline" *ngIf="status === 4"> Updated </span>